import React, { useEffect, useState } from "react";
import { api, formatApiError } from "../../lib/api";
import { toast } from "sonner";
import { MapPin } from "@phosphor-icons/react";

export default function GovComplianceMap() {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/gov/compliance-map").then(r => setData(r.data)).catch(e => toast.error(formatApiError(e)));
  }, []);

  const points = data?.points || [];
  // Bucket scores
  const green = points.filter(p => p.score >= 80).length;
  const amber = points.filter(p => p.score >= 40 && p.score < 80).length;
  const red = points.filter(p => p.score < 40).length;

  return (
    <div className="space-y-4" data-testid="gov-map">
      <div>
        <h1 className="font-heading text-3xl">Compliance Map</h1>
        <p className="text-sm text-[#5C5A55] mt-1">Citizen compliance hotspots · {points.length} points</p>
      </div>

      <div className="grid grid-cols-3 gap-3">
        <Bucket label="Compliant" count={green} color="#2D5A27"/>
        <Bucket label="Warning" count={amber} color="#C89E3E"/>
        <Bucket label="At Risk" count={red} color="#C25D38"/>
      </div>

      <div className="bg-white border border-[#E5E2D9] rounded-md">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-[#F7F6F2] text-left text-[11px] uppercase tracking-[0.2em] text-[#5C5A55]">
              <th className="px-6 py-3">Code</th>
              <th className="px-6 py-3">Citizen</th>
              <th className="px-6 py-3">Location</th>
              <th className="px-6 py-3">Status</th>
              <th className="px-6 py-3 text-right">Score</th>
            </tr>
          </thead>
          <tbody>
            {points.length === 0 && <tr><td colSpan={5} className="px-6 py-12 text-center text-[#8A8780]">No GPS-tagged citizens.</td></tr>}
            {points.map((p, i) => (
              <tr key={p.id} className={i % 2 === 0 ? "bg-white" : "bg-[#FAFAF7]"}>
                <td className="px-6 py-3 font-mono text-xs">{p.customer_code || "—"}</td>
                <td className="px-6 py-3 font-medium">{p.name}</td>
                <td className="px-6 py-3 text-xs text-[#5C5A55] flex items-center gap-1">
                  <MapPin size={12}/>{p.latitude?.toFixed(4)}, {p.longitude?.toFixed(4)}
                </td>
                <td className="px-6 py-3 capitalize">{p.status}</td>
                <td className="px-6 py-3 text-right">
                  <span className={`px-2 py-0.5 rounded text-xs font-mono font-bold ${p.score >= 80 ? "bg-[#D4E0D1] text-[#2D5A27]" : p.score >= 40 ? "bg-[#F9E4B7] text-[#7A5A11]" : "bg-[#F4C7B9] text-[#7A2E18]"}`}>
                    {p.score}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const Bucket = ({ label, count, color }) => (
  <div className="bg-white border border-[#E5E2D9] rounded-md p-5">
    <div className="flex items-center gap-2">
      <div className="w-3 h-3 rounded-full" style={{ background: color }}/>
      <div className="text-[10px] uppercase tracking-[0.2em] text-[#8A8780]">{label}</div>
    </div>
    <div className="font-heading text-3xl mt-1">{count}</div>
  </div>
);
